import moment from "moment";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import queryString from 'query-string';
import userlogo from '../../assets/images/user-logo.png'
import ReactReadMoreReadLess from "react-read-more-read-less";

import { getStorage, onChange, validateForm } from "../../utils";
import Shimmer from "../Common/Shimmer";
import FileSaver from "file-saver";
import constant from "../../constant";
import { withRouter } from "react-router-dom";
import ModalWindow from "../Common/ModalWindow";
import JobsModalList from "./JobModal";
import { applyJobThroughDatabaseSearch } from "../../action/databaseSearch";
import Swal from "sweetalert2";
import Loader from "../Common/Loader";
class CandidateSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: { name: 'message', value: "", error: "" },
            JOB_ID: "",
            recuiterDetail: getStorage(constant.keys.userDetails),
            PAGE: { name: "PAGE", value: 1, error: "", isRequired: false },
            KEYWORD: {
                name: "KEYWORD",
                value: props.KEYWORD ? props.KEYWORD : "",
                error: "",
                isRequired: true,
            },
            EXPERIENCE: {
                name: 'EXPERIENCE', value: '', options: [
                    { name: 'Choose Experience', value: '' },
                    { name: '0-1 Year', value: '0,1' },
                    { name: '1-3 Year', value: '1,3' },
                    { name: '3-5 Year', value: '3,5' },
                    { name: '5-7 Year', value: '5,7' },
                    { name: '7-10 Year', value: '7,10' },
                    { name: '10-12 Year', value: '10,12' },
                    { name: '12-14 Year', value: '12,14' },
                    { name: '14-16 Year', value: '14,16' },
                    { name: '16-18 Year', value: '16,18' },
                    { name: '18-20 Year', value: '18,20' },
                    { name: '20-25 Year', value: '20,25' },
                    { name: '25-30 Year', value: '25,30' },
                    { name: '30+ Year', value: '30+' },


                ], error: "", isRequired: false
            },
            SALARY: {
                name: 'SALARY', value: '', options: [{ name: 'Salary (In Lakh)', value: '' },
                { name: '0-5 Lacs', value: '0-5' },
                { name: '5-10 Lacs', value: '5-10' },
                { name: '11-15 Lacs', value: '11-15' },
                { name: '16-20 Lacs', value: '16-20' },
                { name: '21-30 Lacs', value: '21-30' },
                { name: '31-40 Lacs', value: '31-40' },
                { name: '41-50 Lacs', value: '41-50' },
                { name: '51-60 Lacs', value: '51-60' },
                { name: '61-70 Lacs', value: '61-70' },
                { name: '71-80 Lacs', value: '71-80' },
                { name: '81-90 Lacs', value: '81-90' },
                { name: '91-100 Lacs', value: '91-100' },
                { name: '1 Cr+', value: '100+' },
                ], error: "", isRequired: false
            },
            showApplyModal: false,
            CANDIDATE_ID: undefined,
            SHOW_LOADER: props.SHOW_LOADER

        };
    }


    applyJob = (JOB_ID) => {
        this.setState({ SHOW_LOADER: true })
        applyJobThroughDatabaseSearch({ JOB_ID: JOB_ID, CANDIDATE_ID: this.state.CANDIDATE_ID }).then(res => {
            this.setState({ SHOW_LOADER: false })
            if (res.status) {
                Swal.fire({
                    icon: "success",
                    text: res.result.message,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    text: res.error,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            }
        })

    }
    onShowApplyModal = (CANDIDATE_ID) => {
        this.setState({ showApplyModal: true, CANDIDATE_ID: CANDIDATE_ID });
    };

    onhideApplyModal = () => {
        this.setState({ showApplyModal: false, CANDIDATE_ID: undefined });
    };


    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value);

    };

    downloadResume = (input) => {
        const RESUME_FILE = input.RESUME_FILE;
        const CANDIDATE_ID = input.CANDIDATE_ID;
        FileSaver.saveAs(
            `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`,
            RESUME_FILE
        );
    };


    onPageChange = (input) => {
        onChange(this, this.state.PAGE.name, input, () => {
            const { KEYWORD, EXPERIENCE, SALARY, PAGE } = this.state
            if (validateForm(this)) {
                const model = {
                    KEYWORD: KEYWORD.value,
                    SKILL: [],
                    EXPERIENCE: EXPERIENCE.value,
                    SALARY: SALARY.value,
                    PAGE: PAGE.value
                }
                this.props.onSearch(model)
            }
        });

    }
    onSearch = (e) => {
        e.preventDefault();
        const { KEYWORD, EXPERIENCE, SALARY, PAGE } = this.state
        if (validateForm(this)) {
            const model = {
                KEYWORD: KEYWORD.value,
                SKILL: [],
                EXPERIENCE: EXPERIENCE.value,
                SALARY: SALARY.value,
                PAGE: PAGE.value
            }
            this.props.onSearch(model)
        }
    }


    render() {
        const { PAGE, KEYWORD, SALARY, EXPERIENCE, showApplyModal, SHOW_LOADER } = this.state
        const { SEARCHED_LIST, COUNT, message } = this.props
        const qParam = queryString.parse(this.props?.location?.search)
        return (

            <React.Fragment>
                <section className='pricing-area padding-top-70px padding-bottom-80px'>
                    {SHOW_LOADER && <Loader />}
                    <div className='filterareabox'>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="paginationshowbox" style={{ marginTop: '15px', marginBottom: '10px' }}>
                                        <ul>
                                            <Pagination
                                                activePage={PAGE.value}
                                                itemsCountPerPage={10}
                                                totalItemsCount={COUNT ? COUNT : 0}
                                                pageRangeDisplayed={5}
                                                onChange={this.onPageChange}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                            />
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            {COUNT === undefined && (
                                <div className="col-md-12">
                                    <Shimmer />
                                </div>
                            )}
                            {COUNT !== undefined && (
                                <div className="col-md-12">
                                    <div className="search-box-top">
                                        <div className="search-box search-inner-box">
                                            <form className="rseachbox row" onSubmit={this.onSearch}>
                                                <div className="col-md-4 pdlr0">
                                                    <input
                                                        name={KEYWORD.name}
                                                        value={KEYWORD.value}
                                                        onChange={this.onChange}
                                                        type="text"
                                                        placeholder="Enter Skill, Candidate Name, Email, Phone No."
                                                    />
                                                </div>
                                                <div className="col-md-2 pdlr0">
                                                    <select
                                                        className=""
                                                        name={SALARY.name}
                                                        value={SALARY.value}
                                                        onChange={this.onChange}
                                                    >
                                                        {SALARY.options.map((item) => {
                                                            return (<option value={item.value}>{item.name}</option>)
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-2 pdlr0">
                                                    <select
                                                        name={EXPERIENCE.name}
                                                        value={EXPERIENCE.value}
                                                        onChange={this.onChange}
                                                    >
                                                        {EXPERIENCE.options.map((item) => {
                                                            return (<option value={item.value}>{item.name}</option>)
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-2 pdlr0">
                                                    <button type="submit">
                                                        Search <i className="fa fa-search" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </form>
                                        </div>

                                    </div>

                                    {
                                        SEARCHED_LIST.length > 0 ? SEARCHED_LIST.map((item, index) => {
                                            return (
                                                <div className="lob-list-item jm-job-layout-2">

                                                    <div className="jm-latest-job-item-3 mb-30">
                                                        <div className="jm-latest-job-item-top-3">
                                                            <div className="jm-latest-job-item-top-wrap-3">
                                                                <div className="prof-info-bx">
                                                                    <div className="jm-latest-job-item-logo-3 y_img">
                                                                        <a >
                                                                            <img src={item.PROFILE_IMAGE ? `${process.env.REACT_APP_BASE_URL}/candidate/pic/${item.CANDIDATE_ID}/${item.PROFILE_IMAGE}` : userlogo} alt="" />
                                                                        </a>
                                                                    </div>
                                                                    <div className="jm-latest-job-item-info-3">
                                                                        <h3 className="jm-latest-job-item-info-title-3">

                                                                            <div>
                                                                                <span>{item.CANDIDATE_NAME}</span>

                                                                            </div>
                                                                        </h3>
                                                                        <p className="jm-latest-job-item-info-subtitle-3" >
                                                                            {item.PROFILE_SUMMARY != null
                                                                                ? <ReactReadMoreReadLess
                                                                                    charLimit={250}
                                                                                    readMoreText={"Read more"}
                                                                                    readLessText={"Read less"}
                                                                                >
                                                                                    {(item.PROFILE_SUMMARY)}
                                                                                </ReactReadMoreReadLess>

                                                                                : <span style={{ color: 'orange' }}>Profile Summary Not Available</span>
                                                                            }
                                                                        </p>

                                                                    </div>
                                                                </div>
                                                                <div className="other-info-box first">
                                                                    <div className="key-info key-info-first text-center">
                                                                        <h5>Key Information</h5>

                                                                    </div>
                                                                    <div className="jm-latest-job-meta-wrapper key-info-second">
                                                                        <ul className="list-job-info">
                                                                            <li><span><i className="la la-map-marker"></i> Current Location:</span> {item.CURRENT_LOCATION}</li>
                                                                            <li><span><i className="la la-briefcase"></i> Exp:</span> {item.TOTAL_EXP_YEAR}{" "}
                                                                                Year(s) {item.TOTAL_EXP_MONTH} Month(s) | CTC:
                                                                                Rs {item.CTC} Lakhs</li>
                                                                            <li><span><i className="la la-industry"></i> Industry:</span> {item.INDUSTRY}</li>
                                                                            <li><span><i className="la la-industry"></i> Functional Area:</span> {item.FUNCTIONAL_AREA}</li>
                                                                            <li><span><i className="la la-graduation-cap"></i>  Education:</span>  {item.EDUCATION}</li>
                                                                            <li><span><i className="la la-graduation-cap"></i>  Current Designation:</span>  {item.CURRENT_DESIGNATION && item.CURRENT_DESIGNATION.length > 0 ? item.CURRENT_DESIGNATION : 'Not Available'}</li>
                                                                            <li><span><i className="la la-map-marker"></i>  Pref Location:</span>  {item.prefferedLocation.length > 0
                                                                                ? item.prefferedLocation.map((i, key) => {
                                                                                    if (
                                                                                        key ==
                                                                                        item.prefferedLocation.length - 1
                                                                                    ) {
                                                                                        return i.CITY;
                                                                                    } else {
                                                                                        return i.CITY + ",";
                                                                                    }
                                                                                })
                                                                                : "Not Available"}</li>
                                                                            {item.NOTICE_PERIOD && <li><span><i className="la la-graduation-cap"></i>  Notice Period:</span>  {item.NOTICE_PERIOD}</li>}

                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div className="other-info-box second">
                                                                    <div className="key-info key-info1 text-center">
                                                                        <h5>Key Skills</h5>

                                                                    </div>
                                                                    <div className="jm-latest-job-meta-wrapper">
                                                                        {item.SKILL.length > 0
                                                                            ? item.SKILL.map((i, key) => {
                                                                                return <a>{i.SKILL}</a>;

                                                                            })
                                                                            : <b> Not Available</b>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="jm-latest-job-item-btn-3">

                                                                <a className="jm-theme-btn jm-resume-down-btn"
                                                                    onClick={() => {
                                                                        this.downloadResume(item);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-download"></i>  Download Resume
                                                                </a>
                                                                <span className="jm-resume-down-btn"
                                                                >
                                                                    Added By <span style={{ color: '#c29f11' }}>{item.ADDED_BY}</span>
                                                                </span>

                                                                <a className="jm-theme-btn jm-sendmail-btn"
                                                                    style={{ fontSize: '12px' }}
                                                                    onClick={() => this.onShowApplyModal(item.CANDIDATE_ID)}
                                                                >
                                                                    Apply this Candidate for the Job
                                                                </a>
                                                                <a className="applied-date jm-theme-btn" style={{ marginTop: '10px' }}>Member Since {moment(item.CREATED_ON).format("DD MMM YYYY")}{" "}</a>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>)
                                        }) : <div className="lob-list-item jm-job-layout-2 text-danger" style={{ fontSize: '20px' }} >
                                            <div className="jm-latest-job-item-3 mb-30">
                                                <div className="jm-latest-job-item-top-3">
                                                    <div className="jm-latest-job-item-top-wrap-3">
                                                        {message}
                                                    </div >
                                                </div >
                                            </div >
                                        </div>}
                                </div >
                            )
                            }
                        </div>
                    </div >
                </section >
                {
                    showApplyModal && (
                        <ModalWindow
                            title="SEARCH JOB"
                            backdrop="static"
                            toggleModal={this.onhideModal}
                        >
                            <JobsModalList
                                onCancel={this.onhideApplyModal}
                                onApply={(data) => {
                                    this.applyJob(data);
                                }}
                            />
                        </ModalWindow>
                    )
                }
            </React.Fragment >
        );
    }


}
export default withRouter(CandidateSearch)



